var version = {
    "name":      "dativery",
    "buildDateCode": "20260315-195639",
    "buildDate": "Sun Mar 15 2026 19:56:39 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260315-195639",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;